function create(f, ...context) {
  return async function (...runContext) {
    return await f(...context, ...runContext);
  };
}

function pipe(...fns) {
  return function (x) {
    return fns.reduce((v, f) => f(v), x);
  };
}

export function filterMainOnly(item, userInfo) {
  return !item.mainOnly || (userInfo.userId && item.mainOnly === userInfo.isMain);
}

export {create as createFun};
export {pipe as pipeFun};
